<div class="container">
  <div class="row">
    <div class="col-md-6 text-center width-30">
<!--      <img src='assets/images/price-3.svg' alt='unavailable' />-->
      <img src='assets/images/kdm_btn_dark.jpg' alt='unavailable' />
    </div>

    <div class="col-md-6">
      <p>
        {{ 'sections.programs.inProgressProgram.paragraphText' | translate }}
      </p>
      <p id='font-icon'>
        {{ 'sections.programs.inProgressProgram.paragraphText1' | translate }}! <img src='assets/images/price-3.svg' alt='unavailable' />
      </p>
    </div>
  </div>
</div>
